import { render, staticRenderFns } from "./DeleteFolder.vue?vue&type=template&id=2e2c2e84&"
import script from "./DeleteFolder.vue?vue&type=script&lang=ts&"
export * from "./DeleteFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports